import { Pipe, PipeTransform } from '@angular/core'
import { IQuestion } from 'shared-lib'

@Pipe({
  name: 'questionTypeCount',
})
export class QuestionTypeCountPipe implements PipeTransform {
  transform(questions: IQuestion[], value: string) {
    return questions.filter(q => q.type === value).length ?? 0
  }
}
